const logMaker = (authenticatedUser, eventIndex) => {
  const zoom = 13
  const size = `${window.innerWidth - 30}x80`
  const mapsStaticURL = 'https://maps.googleapis.com/maps/api/staticmap?'
  const mapStyle = `feature:all|element:labels|visibility:simplified&style=feature:all|element:labels.text|color:0x444444&style=feature:administrative.country|element:all|visibility:simplified&style=feature:administrative.country|element:geometry|visibility:simplified&style=feature:administrative.province|element:all|visibility:off&style=feature:administrative.locality|element:all|visibility:simplified|saturation:-100|lightness:30&style=feature:administrative.neighborhood|element:all|visibility:off&style=feature:administrative.land_parcel|element:all|visibility:off&style=feature:landscape|element:all|visibility:simplified|gamma:0.00|lightness:74&style=feature:landscape|element:geometry|color:0xffffff&style=feature:poi|element:all|visibility:off&style=feature:road|element:geometry|visibility:simplified|color:0xff0000|saturation:-15|lightness:40|gamma:1.25&style=feature:road|element:labels|visibility:off&style=feature:transit|element:labels|visibility:simplified&style=feature:transit|element:labels.icon|visibility:off&style=feature:transit.line|element:geometry|color:0xff0000|lightness:80&style=feature:transit.station|element:geometry|color:0xe5e5e5&style=feature:water|element:geometry|color:0xefefef&style=feature:water|element:labels|visibility:off`
  const iterations = authenticatedUser.events[eventIndex].iterations
  const notifications = authenticatedUser.events[eventIndex].notifications
  const myID = authenticatedUser.id
  const myFirstName = authenticatedUser.first_name
  const myLastName = authenticatedUser.last_name
  const connections = authenticatedUser.connections

  const notificationsNotified = notifications.filter(
    logEvent => logEvent.type === 'emergency' && logEvent.is_sent
  )

  const resetsAndNotifications = [...iterations, ...notificationsNotified].sort(
    (a, b) => {
      return a.created < b.created ? -1 : 1
    }
  )

  return resetsAndNotifications.map(logEvent => {
    // Checks if logEvent is a Reset event or a notification
    if (logEvent.lat) {
      return {
        ...logEvent,
        mapURL: `${mapsStaticURL}center=${logEvent.lat},${
          logEvent.lng
        }&zoom=${zoom}&size=${size}&markers=${logEvent.lat},${
          logEvent.lng
        }&key=${process.env.REACT_APP_GOOGLE_GEOENCODING_API_KEY}&style=${mapStyle}`
      }
    } else {
      const defaultPerson = {
        first_name: 'rem.',
        last_name: 'contact',
        title: 'contact'
      }

      const getFirstName = (userID, connections) => {
        if (myID === userID) {
          return myFirstName
        } else {
          return connections.find(
            connection => userID === connection.contacts_id
          ) === undefined
            ? defaultPerson.first_name
            : connections.find(connection => userID === connection.contacts_id)
                .first_name
        }
      }

      const getLastName = (userID, connections) => {
        if (myID === userID) {
          return myLastName
        } else {
          // return connections.find(
          // connection => userID === connection.contacts_id
          // ).last_name
          return connections.find(
            connection => userID === connection.contacts_id
          ) === undefined
            ? defaultPerson.last_name
            : connections.find(connection => userID === connection.contacts_id)
                .last_name
        }
      }

      const getTitle = (userID, connections) => {
        if (myID === userID) {
          //
        }
        // return connections.find(connection => userID === connection.contacts_id)
        //   .title
        return connections.find(
          connection => userID === connection.contacts_id
        ) === undefined
          ? defaultPerson.title
          : connections.find(connection => userID === connection.contacts_id)
              .title
      }

      return {
        ...logEvent,
        first_name: getFirstName(logEvent.users_id, connections),
        last_name: getLastName(logEvent.users_id, connections),
        title: getTitle(logEvent.users_id, connections)
      }
    }
  })
}
export default logMaker
